<template>
  <div class="absolute-0 z-overlay" :style="{ height: `calc(100vh - ${pxToRem(header.height.navigation)})` }">
    <vf-button :aria-label="$t.close" class="absolute right-0 top-0 z-1 mr-4 mt-4 p-3" @click="$emit('close')">
      <vf-icon name="close" size="md" />
    </vf-button>

    <base-carousel class="h-full f-col center" class-container="full" class-wrapper="full">
      <slot />

      <template #prev="{ active, action }">
        <vf-button
          :aria-label="$t.previous"
          class="absolute right-0 z-1 mb-4 mr-4 rounded-full p-3 <md:hidden"
          :disabled="!active"
          style="bottom:50%"
          @click="action"
        >
          <vf-icon dir="left" name="arrow" size="md" />
        </vf-button>
      </template>

      <template #next="{ active, action }">
        <vf-button
          :aria-label="$t.next"
          class="absolute right-0 top-1/2 z-1 mr-4 rounded-full p-3 <md:hidden"
          :disabled="!active"
          @click="action"
        >
          <vf-icon name="arrow" size="md" />
        </vf-button>
      </template>

      <template #pagination="{ active, pages }">
        <vf-progress-bar class="absolute bottom-0 mx-a my-6 w-1/2 md:my-8" :max="pages" :value="active + 1" />
      </template>
    </base-carousel>

    <p v-if="title" class="absolute title-4 <md:hidden" :class="classTitle" style="top:2rem;left:1.875rem">
      {{ title }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  title?: string
  classTitle?: CSSClass
}>()

defineEmits<{
  (e: 'close'): void
}>()

const header = useHeaderStore()
</script>
